import { createFileRoute } from "@tanstack/react-router";
import ProductHubList from "@/pages/ProductHubList";

export const Route = createFileRoute("/lawn-mowers/buying-guides")({
  component: () => <ProductHubList hubSlug="lawn-mowers" variant="buying-guides" />,
});
